import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './StickyJumpNav.scss';

export function StickyJumpNav({ links, activeLink, onLinkClick }) {
	// The nav scrolls horizontally on narrow viewports (see
	// StickyJumpNav.scss) and can overflow before all tabs fit - without
	// this, a scroll-spy change to a tab past the visible edge (e.g.
	// Reviews on a 320px phone) leaves the highlight off-screen with no
	// visible active tab at all.
	const linkRefs = useRef(new Map());

	useEffect(() => {
		linkRefs.current.get(activeLink)?.scrollIntoView?.({
			inline: 'nearest',
			block: 'nearest',
			behavior: 'smooth',
		});
	}, [activeLink]);

	return (
		<nav
			className="sticky-jump-nav"
			aria-label="Facility page sections"
		>
			{links.map((link) => (
				<button
					key={link.id}
					ref={(element) => {
						if (element) {
							linkRefs.current.set(link.id, element);
						} else {
							linkRefs.current.delete(link.id);
						}
					}}
					type="button"
					className={classnames('sticky-jump-nav-link', {
						active: activeLink === link.id,
					})}
					aria-current={activeLink === link.id ? 'true' : undefined}
					onClick={(event) => onLinkClick(link.id, event)}
				>
					{link.label}
				</button>
			))}
		</nav>
	);
}

StickyJumpNav.propTypes = {
	links: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
		}),
	).isRequired,
	activeLink: PropTypes.string,
	// Called as onLinkClick(sectionId, event) - a plain handler, not a
	// curried factory.
	onLinkClick: PropTypes.func.isRequired,
};

export default StickyJumpNav;
